import Vue from "vue";
import VueI18n from "vue-i18n";
import { messages, SUPPORTED_LOCALES, DEFAULT_LOCALE } from "@/locales";

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages,
  silentFallbackWarn: true,
});

/**
 * Maps a language code (e.g. "fr-FR", "es_MX", "en-us") to a supported locale:
 * exact match first, then a match on the base language. Returns null if none match.
 */
export function resolveLocale(code) {
  if (!code || typeof code !== "string") return null;
  const normalized = code.replace("_", "-").toLowerCase();
  const exact = SUPPORTED_LOCALES.find((locale) => locale.toLowerCase() === normalized);
  if (exact) return exact;
  const base = normalized.split("-")[0];
  return SUPPORTED_LOCALES.find((locale) => locale.toLowerCase().split("-")[0] === base) || null;
}

/**
 * The language to activate: the user's preferred language when `feature-multi-lingual`
 * is on, otherwise always DEFAULT_LOCALE.
 */
export function resolveActiveLanguage(featureFlags, userProfile) {
  return featureFlags?.["feature-multi-lingual"] ? userProfile?.language : DEFAULT_LOCALE;
}

/**
 * Activates the best locale for `code`, falling back to the browser language and then
 * DEFAULT_LOCALE. Returns the locale that was applied.
 */
export function setLocale(code) {
  const browserLanguage = typeof navigator !== "undefined" ? navigator.language : null;
  const locale = resolveLocale(code) || resolveLocale(browserLanguage) || DEFAULT_LOCALE;
  i18n.locale = locale;
  if (typeof document !== "undefined") document.documentElement.setAttribute("lang", locale);
  return locale;
}

export default i18n;
